import { useEffect } from 'react';

/**
 * Hook to detect clicks outside a referenced element
 * @param {React.RefObject} ref - Reference to the element
 * @param {Function} handler - Callback when click occurs outside
 */
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, handler]);
};

export default useClickOutside;
